function VerifyHrefContent(params) {
  // 創建一個新的 URLSearchParams 來保存驗證後的參數
  const sanitizedParams = new URLSearchParams();

  // 迭代所有參數並進行驗證
  for (const [key, value] of params) {
    // 檢查鍵和值是否包含合法字符
    if (IsValidInput(key) && IsValidInput(value)) {
      // 將合法的參數加入到驗證後的參數中
      sanitizedParams.append(key, value);
    }
  }

  return sanitizedParams;
}

// 驗證輸入是否包含合法字符
function IsValidInput(input) {
  // 排除特定字符，允許英文日文中文等其他符號，for路標名稱
  const disallowedCharsRegex = /[<>\"']/;
  return !disallowedCharsRegex.test(input);
}

$(document).ready(() => {
  document.title = "列管污染源資料 (含裁處資訊) 查詢系統-依關鍵字查詢"

  let column = "FacilityName";
  async function checkWaste(key, val) {
    $(".modal_notification .text").text(``);
    let data = await fetch("js/json/waste.json").then((res) => res.json());
    let filter = data.waste.filter((d) => d[key] === val);
    return filter;
  }
  $("body").click(function () {
    $(".list_dropdown").fadeOut();
  });
  $(".search_btn").on("click", async function (e) {
    let val = $(".input_button").val();
    if (val == "") {
      $(".modal_notification .title").text("請輸入列管事業名稱或代碼");
      $(".modal_notification").fadeIn();
      $(".modal_notification").css("display", "flex");
      $("body").css("overflow", "hidden");
    } else {
      let valid = true;
      if (column === "WasteItem" || column === "WasteItemCode") {
        let Type = column === "WasteItem" ? "Waste_no" : "Waste_name";
        let check = await checkWaste(Type, val);
        if (check.length === 0) {
          valid = false;
          $(".modal_notification .title").text(`查無此${column === "WasteItem" ? "廢棄物代碼" : "廢棄物名稱"}`);
          if (column === "WasteItem") {
            $(".modal_notification .text").text(`依廢棄物代碼查詢範例：「D-1801」`);
          }
          $(".modal_notification").fadeIn();
          $(".modal_notification").css("display", "flex");
          $("body").css("overflow", "hidden");
        }
      }
      if (valid) {
        const sanitizedParams = VerifyHrefContent([
          ["type", "1"],
          ["keyword", val],
          ["column", column],
          ["PageNumber", "1"],
          ["PageSize", "5"],
        ]);

       // const url = `./info.html?${sanitizedParams.toString()}`;
          const url = `./info.html?${sanitizedParams.toString()}`;
        localStorage.removeItem("selected_items");
        window.location.href = url;
      }
    }
  });
  $(".dropdown > button").click(function (e) {
    console.log(e)
    e.stopPropagation();
    const button = e.currentTarget;
    let show = $(".select_input_block .list_dropdown").css("display");
    if (show === "none") {
      button.setAttribute("aria-expanded", "true");
      $(".select_input_block .list_dropdown").fadeIn();
    } else {
      button.setAttribute("aria-expanded", "false");
      $(".select_input_block .list_dropdown").fadeOut();
    }
  });
  $(".list_dropdown li > button").click(function (e) {
    e.stopPropagation();
    let text = $(this).text();
    let type = $(this).data("column");
    $(".list_dropdown li").removeClass("selected");
    $(this).parent("li").addClass("selected");
    $(".dropdown .title").text(text);
    $(".list_dropdown").fadeOut();
    $(".input_button").attr("placeholder", text);
    column = type;
  });
  $(".input_button").focus(function () {
    $(".select_input_block").css("border", "2px solid #dd4e21");
  });
  $(".input_button").blur(function () {
    $(".select_input_block").css("border", "1px solid #061d24");
  });

  $(".input_button").on("keyup", async function (e) {
    let val = $(this).val();
    if (e.keyCode === 13) {
      if (val == "") {
        $(".modal_notification .title").text("請輸入列管事業名稱或代碼");
        $(".modal_notification").fadeIn();
        $(".modal_notification").css("display", "flex");
        $("body").css("overflow", "hidden");
      } else {
        let valid = true;
        if (column === "WasteItem" || column === "WasteItemCode") {
          let Type = column === "WasteItem" ? "Waste_no" : "Waste_name";
          let check = await checkWaste(Type, val);
          if (check.length === 0) {
            valid = false;
            $(".modal_notification .title").text(`查無此${column === "WasteItem" ? "廢棄物代碼" : "廢棄物名稱"}`);
            if (column === "WasteItem") {
              $(".modal_notification .text").text(`依廢棄物代碼查詢範例：「D-1801」`);
            }
            $(".modal_notification").fadeIn();
            $(".modal_notification").css("display", "flex");
            $("body").css("overflow", "hidden");
          }
        }
        if (valid) {
          const sanitizedParams = VerifyHrefContent([
            ["type", "1"],
            ["keyword", val],
            ["column", column],
            ["PageNumber", "1"],
            ["PageSize", "5"],
          ]);

          const url = `./info.html?${sanitizedParams.toString()}`;

          localStorage.removeItem("selected_items");
          window.location.href = url;
        }
      }
    }
  });
});
